// extracted by mini-css-extract-plugin
export default {"contentWrapperForProductLayout":"PurchaseCreditsPage_contentWrapperForProductLayout__pI-Jq","orderColumnForProductLayout":"PurchaseCreditsPage_orderColumnForProductLayout__BpoLO"};